/**
 * Formats an ISO timestamp into a user-friendly local date and time string.
 *
 * @param timestamp - ISO 8601 timestamp string (e.g. "2024-06-15T14:30:00.000Z")
 * @returns Formatted string like "Jun 15, 2024 | 2:30 PM", or empty string for falsy/invalid input
 */
export const getLocalDateAndTime = (timestamp?: string) => {
  if (!timestamp) return '';

  const parsed = new Date(timestamp);
  if (isNaN(parsed.getTime())) return '';

  // local date in format - MMM DD, YYYY
  const date = parsed.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  // local time in format - HH:MM AM/PM
  const time = parsed.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
  });

  return `${date} | ${time}`;
};
